module.exports = [
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt3 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30338AL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt3 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30338AL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt4 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30338A01"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt4 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30338A01"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt5 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30338DL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt5 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30338DL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt6 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30338DA1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt0 && duo-spout_opt0 && finish_opt6 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30338DA1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30324001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30324001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30324DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30324DC1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt3 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30324AL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt3 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30324AL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt4 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30324A01"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt4 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30324A01"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt5 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30324DL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt5 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30324DL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt6 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30324DA1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt6 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30324DA1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt1 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30144001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt1 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30144001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt1 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30144DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt1 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30144DC1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DC1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt2 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031KS1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt2 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031KS1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt3 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031AL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt3 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031AL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt4 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031A01"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt4 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031A01"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt5 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt5 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt6 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DA1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt6 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DA1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31498AL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt4"
		],
		"groups": [
			{
				"products": [
					"31498A01"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt5"
		],
		"groups": [
			{
				"products": [
					"31498DL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt6"
		],
		"groups": [
			{
				"products": [
					"31498DA1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31539000",
					"31454001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31539DC0",
					"31454DC1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31454KS1",
					"31539KS0"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31454AL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt4"
		],
		"groups": [
			{
				"products": [
					"31454A01"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt5"
		],
		"groups": [
			{
				"products": [
					"31454DL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt6"
		],
		"groups": [
			{
				"products": [
					"31454DA1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31543000",
					"31456001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31543DC0",
					"31456DC1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31541000",
					"31455001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31541DC0",
					"31455DC1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt2"
		],
		"groups": [
			{
				"products": [
					"31455KS1",
					"31541KS0"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt3"
		],
		"groups": [
			{
				"products": [
					"31455AL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt4"
		],
		"groups": [
			{
				"products": [
					"31455A01"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt5"
		],
		"groups": [
			{
				"products": [
					"31455DL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt6"
		],
		"groups": [
			{
				"products": [
					"31455DA1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt3 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"31454AL1",
					"30338AL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt3 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"31454AL1",
					"30338AL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt4 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"31454A01",
					"30338A01"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt4 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"31454A01",
					"30338A01"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt5 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"31454DL1",
					"30338DL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt5 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DL1",
					"30338DL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt6 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"31454DA1",
					"30338DA1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt0 && duo-spout_opt0 && finish_opt6 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DA1",
					"30338DA1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031001",
					"31498001"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031001",
					"31498001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DC1",
					"31498DC1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DC1",
					"31498DC1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt3 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031AL1",
					"31498AL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt3 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031AL1",
					"31498AL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt4 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031A01",
					"31498A01"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt4 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031A01",
					"31498A01"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt5 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DL1",
					"31498DL1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt5 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DL1",
					"31498DL1"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt6 && filter_opt0"
		],
		"groups": [
			{
				"products": [
					"30031DA1",
					"31498DA1"
				],
				"bundle": [
					"40438001"
				]
			}
		]
	},
	{
		"conditions": [
			"water-type_opt2 && tap_opt1 && main-faucet_opt1 && duo-spout_opt2 && finish_opt6 && filter_opt1"
		],
		"groups": [
			{
				"products": [
					"30031DA1",
					"31498DA1"
				],
				"bundle": []
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_conditions_nl_nl.json
// module id = 862
// module chunks = 0